import runtimeConfig from '@/common/runtime-config';

// Утилиты для OAuth2 Authorization Code + PKCE

function generateRandom(length = 32) {
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

async function sha256Base64Url(plain) {
  const encoder = new TextEncoder();
  const digest = await crypto.subtle.digest('SHA-256', encoder.encode(plain));
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

const STORAGE_KEYS = {
  codeVerifier: 'code_verifier',
  state: 'oauth_state',
  returnUrl: 'login_return_url',
};

/**
 * Формирует URL авторизации IDP и делает redirect.
 * @param {string|null} returnUrl — URL для возврата после логина
 */

export async function redirectToIdp(returnUrl) {
  if (returnUrl) {
    sessionStorage.setItem(STORAGE_KEYS.returnUrl, returnUrl);
  } else {
    sessionStorage.removeItem(STORAGE_KEYS.returnUrl);
  }

  const codeVerifier = generateRandom(32);
  const state = generateRandom(16);
  const nonce = generateRandom(16);

  sessionStorage.setItem(STORAGE_KEYS.codeVerifier, codeVerifier);
  sessionStorage.setItem(STORAGE_KEYS.state, state);

  const codeChallenge = await sha256Base64Url(codeVerifier);
  const { authorizeUrl, clientId, redirectUri, scope, responseType } = runtimeConfig.oidc;

  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: responseType,
    scope,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    state,
    nonce,
  });

  window.location.href = `${authorizeUrl}?${params.toString()}`;
}

export function redirectToBlitzLogout() {
  const { logoutUrl, postLogoutRedirectUri, clientId } = runtimeConfig.oidc;

  const params = new URLSearchParams({
    post_logout_redirect_uri: postLogoutRedirectUri,
    client_id: clientId,
  });

  window.location.href = `${logoutUrl}?${params.toString()}`;
}

/**
 * Извлекает данные колбек из query params.
 * Возвращает { code, codeVerifier, redirectUri, clientId } или бросает ошибку.
 * @param {Object} query — route query params
 */

export function parseCallback(query) {
  if (query.error) return cleanup();

  const savedState = sessionStorage.getItem(STORAGE_KEYS.state);
  if (query.state && query.state !== savedState) return cleanup();

  const codeVerifier = sessionStorage.getItem(STORAGE_KEYS.codeVerifier);

  return {
    code: query.code,
    codeVerifier,
    redirectUri: runtimeConfig.oidc.redirectUri,
    clientId: runtimeConfig.oidc.clientId,
  };
}

export function getReturnUrlAndCleanup() {
  const returnUrl = sessionStorage.getItem(STORAGE_KEYS.returnUrl) || '/';
  cleanup();
  return returnUrl;
}

export function cleanup() {
  sessionStorage.removeItem(STORAGE_KEYS.codeVerifier);
  sessionStorage.removeItem(STORAGE_KEYS.state);
  sessionStorage.removeItem(STORAGE_KEYS.returnUrl);
}
